import promise from 'es6-promise';
promise.polyfill();
import Vue from 'vue';
import store from './store/index';
// import VueRouter from 'vue-router';
// import { routes } from './routes/index';
import router from './routes/index';
import ElementUI from 'element-ui';
import Image from './components/image/index.js';
// import 'element-ui/lib/theme-default/index.css'
import '../css/reset.css';
import '../css/main.less';
import '../css/clues.less';
import '../css/order.less';
import '../css/animate.min.css';
import '../css/metroStyle.css';
import 'element-ui/lib/theme-chalk/index.css';
import '../css/theme/elementCustom/index.css';
import '../iconfont/iconfont.js';
import 'echarts/lib/chart/pie';
import 'echarts/lib/chart/line';
import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/funnel';
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/title';
import { handleLogin } from './util/auth.js';
import { setWindowNID, toUrl, loginPage } from './util/config.js';
import { GetUserNameLoginStatus } from './api/login.js';
import { CRM_MENU } from './util/keys.js';
import { CRM_TOKEN } from "./util/keys.js";
import { getCookie } from "./util/cookie.js";

import App from './App.vue';
Vue.use(ElementUI)
Vue.use(Image);
// Vue.use(router); // router 是实例不是插件，不能直接 use。Router 已在 routes/index.js 中通过 Vue.use(Router) 安装
// const router = new VueRouter({
// 	routes
// });
//路由设置
router.beforeEach(async (to, from, next) => {
	let token = getCookie(CRM_TOKEN)
	// 检查 URL 中是否存在 ssoToken 参数
    const ssoToken = to.query.ssoToken;
    if (ssoToken) {
        try {
			localStorage.clear();
			const { status, result } = await GetUserNameLoginStatus();
			if (status === 0) {
				localStorage.setItem('loginPageStatus', result.status); // 登录页面开关，0: 登录页 1: OA登录
			}
            // 调用 handleLogin 处理 ssoToken 登录
            await handleLogin({ ssoToken, router });
            return; // 登录成功后自动跳转
        } catch (error) {
            // next({ path: '/login' }); // 登录失败跳转到登录页
			window.location.href = loginPage();
            return;
        }
    }

	if (to.path == '/registerSignin' && !token) {
		let hashStr = location.hash.split("?")[1];
		let hash = hashStr.split("&");
		let c;
		let Meeting_No;
		for (let i = 0; i < hash.length; i++) {
			c = hash[i].split("=");
			if (c[0].replace(" ", "") == "meetingno") {
				Meeting_No = c[1];
			}
		}
		window.location.href = `${toUrl()}#/AttendanceVenue?&Meeting_No=${Meeting_No}`
	}
	// 如果没有 token 且访问的不是登录页，跳转到登录页
	if (!token && to.path !== '/login' && (to.path !== '/order/erpDetails') && (to.path !== '/ErpLoginCrm')) {
		next({ path: '/login' })
		return;
	}
	if (!window.CRMMENU) {
		window.CRMMENU = JSON.parse(localStorage.getItem(CRM_MENU));
	}
	setWindowNID(window.CRMMENU, to.path); // window.nid
	// if (to.path == '/cluesIndex') {
	// 	window.nid = 23;
	// }
	store.dispatch('updateCurrentSubMenu', window.nid);

	let title = to.params.title || to.meta.title || '盘古系统';
    document.title = `盘古系统-${title}`;
	
	if (!to.query.url && from.query.url) {
		to.query.url = from.query.url
	}

	setTimeout(() => {
		window.sa.quick('autoTrack') // 埋点
		store.dispatch('updateCurrentTabId', to.path);
		store.dispatch('isTracking', false);
	}, 0)

	next();
});
new Vue({
	store,
	router,
	render: h => h(App),
}).$mount('#app');
